<template>
  <div class="wa__header">
    <button v-if="isMobile" class="wa__back-btn" @click="$emit('back')">
      <i class="fas fa-arrow-left"></i>
    </button>

    <div
      class="wa__avatar wa__avatar--sm"
      :style="{
        backgroundColor: avatarColor(conversation.phoneNumber),
      }"
    >
      {{ getInitials(employeeName) }}
    </div>

    <div class="wa__header-info">
      <div class="wa__header-top">
        <span class="wa__header-name">
          {{ employeeName }}
        </span>
        <span class="wa__header-phone">
          {{ conversation.phoneNumber }}
        </span>
      </div>
      <span class="wa__header-ref">
        Empleado CRESA
        <template v-if="conversation.profile?.branch">
          · {{ conversation.profile.branch }}
        </template>
        <template v-if="conversation.profile?.city">
          · {{ conversation.profile.city }}
        </template>
      </span>
    </div>

    <span
      v-if="conversation?.estimatedCostUsd > 0"
      class="cost-badge"
      :class="costBadgeColor"
    >
      ${{ Number(conversation.estimatedCostUsd).toFixed(2) }}
    </span>

    <div class="wa__header-actions">
      <span class="wa__badge" :class="statusBadgeClass(conversation)">
        {{ statusLabel(conversation) }}
      </span>
      <span class="wa__badge" :class="modeBadgeClass(mode)">
        {{ modeLabel(mode) }}
      </span>
      <button
        v-if="mode === 'bot' || mode === 'paused'"
        type="button"
        class="wa__pause-btn"
        :disabled="togglingMode"
        @click="$emit('pause-bot')"
      >
        <span v-if="togglingMode">
          <i class="fas fa-spinner fa-spin" style="font-size: 12px"></i>
        </span>
        <span v-else>Pausar Bot</span>
      </button>
      <template v-else-if="mode === 'human'">
        <span class="wa__badge wa__badge--orange">Modo asesor</span>
        <button
          type="button"
          class="wa__resume-btn"
          :disabled="togglingMode"
          @click="$emit('resume-bot')"
        >
          <span v-if="togglingMode">
            <i class="fas fa-spinner fa-spin" style="font-size: 12px"></i>
          </span>
          <span v-else>Reanudar Bot</span>
        </button>
      </template>
      <button class="wa__info-btn" @click="$emit('toggle-info')">
        <i class="fas fa-info-circle"></i>
        Info
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaHeader",
  props: {
    conversation: {
      type: Object,
      required: true,
    },
    employeeName: {
      type: String,
      default: "—",
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "bot",
    },
    togglingMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["back", "toggle-info", "pause-bot", "resume-bot"],
  computed: {
    costBadgeColor() {
      const cost = this.conversation?.estimatedCostUsd ?? 0;
      if (cost <= 0) return "";
      if (cost < 0.2) return "success";
      if (cost < 0.3) return "warning";
      if (cost < 0.4) return "orange";
      return "danger";
    },
  },
  methods: {
    getInitials(name) {
      if (!name) return "?";
      const parts = String(name).trim().split(/\s+/);
      if (parts.length === 1) return (parts[0][0] || "?").toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    },
    avatarColor(phone) {
      if (!phone) return "#8696a0";
      let hash = 0;
      for (let i = 0; i < phone.length; i++) {
        hash = phone.charCodeAt(i) + ((hash << 5) - hash);
      }
      return `hsl(${Math.abs(hash) % 360}, 45%, 42%)`;
    },
    statusLabel(conv) {
      if (conv.status === "active") return "Activa";
      if (conv.status === "closed") return "Cerrada";
      return conv.status || "—";
    },
    statusBadgeClass(conv) {
      if (conv.status === "active") return "wa__badge--green";
      if (conv.status === "closed") return "wa__badge--blue";
      return "wa__badge--grey";
    },
    modeLabel(mode) {
      if (mode === "human") return "Asesor";
      if (mode === "paused") return "Pausado";
      return "Bot";
    },
    modeBadgeClass(mode) {
      if (mode === "human") return "wa__badge--orange";
      if (mode === "paused") return "wa__badge--grey";
      return "wa__badge--green";
    },
  },
};
</script>
